import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
  id: PropTypes.string,
};

const SingleColumnGrid = ({
  color = '#B5BCBD',
  size = 18,
  id = 'single-column-grid',
  ...props
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 18 18"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    {...props}
  >
    <defs>
      <path
        d="M3 0h12a3 3 0 0 1 3 3v12a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3z"
        id={`${id}-a`}
      />
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id={`${id}-b`} fill="#fff">
        <use xlinkHref={`#${id}-a`} />
      </mask>
      <path
        d="M3 0h12a3 3 0 0 1 3 3v12a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3z"
        stroke={color}
        strokeWidth="2"
        mask={`url(#${id}-b)`}
      />
    </g>
  </svg>
);

SingleColumnGrid.propTypes = propTypes;

export default SingleColumnGrid;
